import { postData } from "lib/stripe/helpers"
import { useUser } from "lib/supabase/auth"
import { useMutation } from "react-query"

export const useCustomerPortal = () => {
  const { session } = useUser()

  return useMutation<string, Error, void>(async () => {
    const { url, error } = await postData({
      url: "/api/stripe/create-portal-link",
      token: session?.access_token,
    })

    if (error) {
      throw error
    }

    return url
  })
}
